module.exports = __webpack_public_path__ + "img/support.687be441.jpg";